import {useEffect, useSyncExternalStore} from 'react'
import {getRelayProvisioning, getRelayReportedError, subscribeRelayRegistry} from '@github-ui/ahp-relay/relay-registry'
import type {ProvisioningStatus} from '@github-ui/ahp-relay/session-host/resolve-project'
import {getTaskStartup, retainTaskStartup, subscribeTaskStartupStore, type TaskStartup} from './task-startup-store'

/**
 * Reads the repo-project provisioning status the active relay reported for
 * `taskId`. Read-only: it never acquires a relay, so it returns `undefined`
 * until some other consumer (e.g. the session timeline) has one connected.
 */
export function useRelayProvisioning(taskId: string | undefined): ProvisioningStatus | undefined {
  return useSyncExternalStore(
    subscribeRelayRegistry,
    () => getRelayProvisioning(taskId),
    () => undefined,
  )
}

export function useRelayReportedError(taskId: string | undefined): string | undefined {
  return useSyncExternalStore(
    subscribeRelayRegistry,
    () => getRelayReportedError(taskId),
    () => undefined,
  )
}

export function useTaskStartup(taskId: string | undefined): TaskStartup | undefined {
  const taskStartup = useSyncExternalStore(
    subscribeTaskStartupStore,
    () => getTaskStartup(taskId),
    () => undefined,
  )
  const taskStartupStatus = taskStartup?.status

  useEffect(() => {
    if (!taskId || !taskStartupStatus) return
    return retainTaskStartup(taskId)
  }, [taskId, taskStartupStatus])

  return taskStartup
}
